export default __webpack_public_path__ + "static/media/Card.52362f9e.jpeg";